/* OMINA 3.0 — comportements légers.
   Deux rôles seulement, aucun framework, aucune interception du défilement :
   1. état « détaché » du header au défilement (§8.3) ;
   2. comparateur avant/après piloté par un input range natif (§10.4).

   Le défilement de la page reste entièrement natif : la molette, le tactile et
   la barre latérale ne sont jamais captés. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- §8.3 — Header : rattaché au sommet, détaché ensuite --------------- */
  function initHeader() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    var ticking = false;

    function apply() {
      ticking = false;
      // Seuil volontairement bas : le header se détache dès qu'on quitte le hero.
      var detached = window.scrollY > 24;
      header.classList.toggle('omina-header--detached', detached);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    apply();
    // Écoute passive : aucune préemption possible du défilement.
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- §10.4 — Comparateur avant/après ----------------------------------- */
  function initCompare(root) {
    var range = root.querySelector('.omina-compare-slider__range');
    var frame = root.querySelector('.omina-compare-slider__frame');
    if (!range || !frame) return;

    function paint() {
      frame.style.setProperty('--omina-compare-position', range.value + '%');
      range.setAttribute('aria-valuenow', range.value);
    }

    // input couvre souris, tactile et clavier (flèches, Début, Fin).
    range.addEventListener('input', paint);
    paint();
  }

  function init() {
    initHeader();
    document.querySelectorAll('[data-omina-compare]').forEach(initCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Dans l'éditeur Shopify, une section rechargée doit retrouver ses comportements.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;
    if (target.querySelector('.section-header')) initHeader();
    target.querySelectorAll('[data-omina-compare]').forEach(initCompare);
  });

  // Rien à animer si le visiteur a demandé de réduire les animations :
  // le header reste simplement dans son état courant.
  reduceMotion.addEventListener('change', function () {});
})();
